import styled from 'styled-components';

export const DivMain = styled.div`
  flex:'0.70 1 0';
`;
export const DivSide = styled.div`
  flex:'0.30 1 0';
`;


export const DivContainer = styled.div`
  margin-bottom: 10px;
  margin-top: 10px;
  color: rgba(0, 0, 0, 0.6);
`;

export const DivSmallBox = styled.div`
  margin-bottom: 8px;
  display: flex;
  flex: 1;
  margin-top: 8px;
  flex-direction: column;
`;

export const DivSmallItemBox = styled.div`
  margin-bottom: 8px;
  display: flex;
  flex-direction: row;
  margin-top: 8px;
`;

export const DivErrorMessage = styled.div`
  position: relative;
  bottom: 15px;
  font-size: 12px;
  line-height: 12px;
  color: rgb(244, 67, 54);
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  padding-top: 8px;
  margin-top: 16px;
  border-top: 1px solid;
`;

export const DivFormContainer = styled.div`
  padding: 3em 0em 6em 0em;
  @media only screen and (min-width: 768px) {
    padding: 0em 0em 1em 0em;
  }
`;
export const DivFormBox = styled.div`
  padding: 0 1em;
`;

export const DivFormFieldBox = DivFormBox.extend`
    display: flex;
    padding: 16px 1em;
    flex:1;
    flex-direction: column;
`;

export const SectionForm = styled.div`
  flex-direction: column;
  flex: 1;
  &> * {
    margin:16px;
    @media only screen and (min-width: 768px) {
      margin:8px;
      &:first-child {
        flex: 1 ;
      }
    }
  }
    @media only screen and (min-width: 768px) {
      display: flex;
      flex: 1;
      flex-flow: row wrap;
      margin:8px;
      &:first-child {
        margin-right:8px;
      }
      &:last-child {
        margin-left:8px;
      }
    }  
`;

export const FullForm = styled.div`
  margin: 0px 16px;
`;

export const BoxMessage = styled.div`
  display: flex;
  padding: 16px;
  margin-top: 8px;
  background-color: rgba(236, 58, 58, 0.35);
  flex: 1;
`;



// WEBPACK FOOTER //
// ./src/products/styled.js